<template>
  <div>
    <ErrorsMessages :errors="errors" />
    <!-- abre filtrar por período -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="period"
      title="Filtrar por período"
    >
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <label>De</label>
          <input v-model="start_date" type="date" class="form-control" />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <label>Até</label>
          <input v-model="end_date" type="date" class="form-control" />
        </div>
        <div class="col-md-12 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <v-btn class="btn-cancel" @click="handleCancelFilterByPeriod"
            >CANCELAR</v-btn
          >
        </div>
        <div class="col-md-6 pt-0 pb-0 text-right">
          <v-btn
            @click="handleFilterByPeriod"
            :disabled="loading"
            class="btn-filter m-1"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "FILTRAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- fecha filtrar por período -->
    <!-- abre filtrar por contas -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="account"
      title="Filtrar por contas"
    >
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <div class="custom-control custom-checkbox">
            <input
              v-model="all_account"
              type="checkbox"
              class="custom-control-input"
              id="all-account"
              @change="handleAllAccount($event.target.checked)"
            />
            <label class="custom-control-label" for="all-account">TODAS</label>
          </div>
          <b-form-group>
            <b-form-checkbox
              v-for="account in finance_configuration_account"
              v-model="account_ids"
              :key="account.id"
              :value="account.id"
              name="flavour-3a"
              @input="handleAccount"
            >
              {{ account.account_nickname }}
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <v-btn class="btn-cancel" @click="$bvModal.hide('account')"
            ><i class="fas fa-times mr-2 text-twenty"></i>CANCELAR</v-btn
          >
        </div>
        <div class="col-md-6 pt-0 pb-0 text-right">
          <v-btn @click="get" :disabled="loading" class="btn-filter m-1">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "FILTRAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- fecha filtrar por contas -->
    <!-- abre mais filtros -->
    <b-modal
      size="xl"
      no-close-on-backdrop
      hide-footer
      id="filters"
      title="Mais filtros"
    >
      <div class="row">
        <div class="col-md-12">
          <Filters
            :users="users"
            :providers="providers"
            :finance_client="finance_client"
            :finance_configuration_document_types="
              finance_configuration_document_types
            "
            :finance_configuration_payment_methods="
              finance_configuration_payment_methods
            "
            :finance_configuration_category="finance_configuration_category"
            :finance_configuration_category_parents="
              finance_configuration_category_parents
            "
            :finance_configuration_profit_cost_center="
              finance_configuration_profit_cost_center
            "
            :finance_configuration_tag="finance_configuration_tag"
            :cost_types="cost_types"
            :cost_appropriations="cost_appropriations"
            :filters="{
              types_of_entries_ids,
              users_ids,
              provider_ids,
              finance_client_ids,
              finance_configuration_document_types_ids,
              finance_configuration_payment_methods_ids,
              finance_configuration_category_ids,
              finance_configuration_profit_cost_center_ids,
              finance_configuration_tag_ids,
              cost_types_ids,
              cost_appropriations_ids,
            }"
            @success="handleSuccessFilters"
            @cancel="$bvModal.hide('filters')"
          />
        </div>
      </div>
    </b-modal>
    <!-- fecha mais filtros -->
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
        <h1 class="title-pages">LANÇAMENTOS POR CENTROS DE CUSTO/LUCRO</h1>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-right">
        <v-btn
          :disabled="loading"
          @click="$bvModal.show('account')"
          small
          class="btn-filter m-1"
          ><i class="fas fa-filter mr-2 text-twenty"></i>
          {{ loading ? "..." : "FILTRAR POR CONTAS" }}</v-btn
        >
        <v-btn
          :disabled="loading"
          @click="$bvModal.show('filters')"
          small
          class="btn-filter m-1"
          ><i class="fas fa-filter mr-2 text-twenty"></i>
          {{ loading ? "..." : "MAIS FILTROS" }}</v-btn
        >
        <v-btn
          v-if="
            types_of_entries_ids.length > 0 ||
            users_ids.length > 0 ||
            provider_ids.length > 0 ||
            finance_client_ids.length > 0 ||
            finance_configuration_document_types_ids.length > 0 ||
            finance_configuration_payment_methods_ids.length > 0 ||
            finance_configuration_category_ids.length > 0 ||
            finance_configuration_profit_cost_center_ids.length > 0 ||
            finance_configuration_tag_ids.length > 0 ||
            cost_types_ids.length > 0 ||
            cost_appropriations_ids.length > 0
          "
          @click="handleCancelFilters"
          small
          :disabled="loading"
          class="btn-cancel m-1"
        >
          <i class="fas fa-times mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "LIMPAR FILTRO" }}
        </v-btn>
        <v-btn
          v-if="!loading && (pay.length > 0 || receive.length > 0)"
          small
          class="btn-print"
          @click="handlePrint"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <v-btn
          :disabled="loading"
          small
          :class="[cash_competence == 'cash' && 'v-dark']"
          class="submenu-finacial"
          @click="handleClickCashCompetence('cash')"
        >
          {{ loading ? "..." : "Caixa" }}</v-btn
        >
        <v-btn
          :disabled="loading"
          small
          class="submenu-finacial"
          :class="[cash_competence == 'competence' && 'v-dark']"
          @click="handleClickCashCompetence('competence')"
        >
          {{ loading ? "..." : "Competência" }}
        </v-btn>
      </div>
      <div class="col-xl-4 col-lg-5 col-md-6 col-sm-7 col-12">
        <div class="input-group">
          <div class="input-group-pprend">
            <v-btn
              :disabled="loading"
              @click="handlePrevMonth"
              class="v-dark submenu-finacial"
              style="height: 31px"
              small
              ><i class="fas fa-arrow-left"></i
            ></v-btn>
          </div>
          <input
            :disabled="loading"
            v-if="dayMonthYear == 'day'"
            v-model="month"
            type="date"
            class="form-control form-control-sm"
          />
          <input
            :disabled="loading"
            v-if="dayMonthYear == 'month'"
            v-model="month"
            type="month"
            class="form-control form-control-sm"
            @input="get"
          />
          <input
            :disabled="loading"
            v-if="dayMonthYear == 'year'"
            v-model="month"
            type="text"
            class="form-control form-control-sm"
            maxlength="4"
            minlength="4"
            @input="handleInputMonthTypeYear($event.target.value)"
          />
          <div class="input-group-pprend">
            <v-btn
              :disabled="loading"
              @click="handleNextMonth"
              class="v-dark submenu-finacial"
              style="height: 31px"
              small
            >
              <i class="fas fa-arrow-right"></i>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-3 col-md-6 col-sm-5 col-12">
        <v-btn
          :disabled="loading"
          small
          @click="handleDayMonthYear('day')"
          class="submenu-finacial"
          :class="[dayMonthYear == 'day' && 'v-dark']"
          >Dia</v-btn
        >
        <v-btn
          :disabled="loading"
          small
          class="submenu-finacial"
          @click="handleDayMonthYear('month')"
          :class="[dayMonthYear == 'month' && 'v-dark']"
          >Mês</v-btn
        >
        <v-btn
          :disabled="loading"
          small
          class="submenu-finacial"
          @click="handleDayMonthYear('year')"
          :class="[dayMonthYear == 'year' && 'v-dark']"
          >Ano</v-btn
        >
        <v-btn
          small
          v-if="dayMonthYear == 'day'"
          :disabled="loading"
          class="submenu-finacial v-dark"
          @click="get"
          ><i class="fas fa-filter mr-1"></i> FILTRAR</v-btn
        >
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 text-right">
        <v-btn
          v-if="filter_by_period"
          @click="handleCancelFilterByPeriod"
          small
          :disabled="loading"
          class="btn-cancel p-2 ml-1 mr-1"
        >
          <i class="fas fa-times mr-2"></i>
          <span v-if="loading">CARREGANDO</span>
          <span v-if="!loading">LIMPAR FILTRO POR PERÍODO</span>
        </v-btn>
        <v-btn
          small
          :disabled="loading"
          @click="handleModalFilterByPeriod"
          class="btn-filter p-2 ml-1 mr-1"
          ><i class="fas fa-filter mr-2"></i> Filtrar por período</v-btn
        >
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div
        class="v-clean p-5 text-center"
        v-show="pay.length == 0 && receive.length == 0"
      >
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <div class="row" v-show="pay.length > 0 || receive.length > 0">
        <div class="col-md-6">
          <h4 class="v-success noBorderRadius p-2">Receitas</h4>
          <div class="border mt-2 mb-2 p-2">
            <GChart
              :settings="{ packages: ['corechart'] }"
              type="PieChart"
              :data="dataReceive"
              :options="{
                pieHole: 0.4,
                height: 400,
              }"
            />
          </div>
          <div
            v-for="(item, key) in receive"
            :key="key"
            class="row m-0 border-bottom"
          >
            <div class="col-md-8 d-flex align-items-center p-0">
              <span class="ml-2">{{ item.description }}</span>
            </div>
            <div class="col-md-4 p-0 text-right">
              <span class="c-success">
                {{ formatMoney(String(item.total)) }}
              </span>
              <small class="ml-2">({{ item.percentage }}%)</small>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-md-8 p-0"><b>Total</b></div>
            <div class="col-md-4 p-0 c-success text-right">
              {{ formatMoney(String(total_receive)) }}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <h4 class="v-danger noBorderRadius p-2">Despesas</h4>
          <div class="border mt-2 mb-2 p-2">
            <GChart
              :settings="{ packages: ['corechart'] }"
              type="PieChart"
              :data="dataPay"
              :options="{
                pieHole: 0.4,
                height: 400,
              }"
            />
          </div>
          <div
            v-for="(item, key) in pay"
            :key="key"
            class="row m-0 border-bottom"
          >
            <div class="col-md-8 d-flex align-items-center p-0">
              <span class="ml-2">{{ item.description }}</span>
            </div>
            <div class="col-md-4 p-0 text-right">
              <span class="c-danger">
                -{{ formatMoney(String(item.total)) }}
              </span>
              <small class="ml-2">({{ item.percentage }}%)</small>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-md-8 p-0"><b>Total</b></div>
            <div class="col-md-4 p-0 c-danger text-right">
              -{{ formatMoney(String(total_pay)) }}
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <h4 class="v-dark noBorderRadius p-2">Resumo do período</h4>
          <div class="row d-flex align-items-center">
            <div class="col-md-3">
              <p class="m-0 worksansr">Total de ganhos</p>
            </div>
            <div class="col-md-7">
              <b-progress
                variant="success"
                :value="total_receive"
                :max="max_progress"
              />
            </div>
            <div class="col-md-2">
              <p class="m-0 c-success">
                {{ formatMoney(String(total_receive)) }}
              </p>
            </div>
          </div>
          <div class="row d-flex align-items-center">
            <div class="col-md-3">
              <p class="m-0 worksansr">Total de gastos</p>
            </div>
            <div class="col-md-7">
              <b-progress
                variant="danger"
                :value="total_pay"
                :max="max_progress"
              />
            </div>
            <div class="col-md-2">
              <p class="m-0 c-danger">-{{ formatMoney(String(total_pay)) }}</p>
            </div>
          </div>
          <div class="row d-flex align-items-center">
            <div class="col-md-3">
              <p class="m-0 worksansr">Resultado do período</p>
            </div>
            <div class="col-md-7">
              <b-progress
                variant="success"
                :value="period_result"
                :max="max_progress"
              />
            </div>
            <div class="col-md-2">
              <p
                :class="[
                  'm-0',
                  period_result >= 0 && 'c-success',
                  period_result < 0 && 'c-danger',
                ]"
              >
                {{ formatMoney(String(period_result)) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";

import ErrorsMessages from "../../Components/ErrorsMessages";

import Filters from "../Releases/List/Filters";

import api from "../../../services/api";

import { formatMoney, isNumeric } from "../../../lib/format";

import moment from "moment";

export default {
  name: "ReleasesByCategory",
  components: {
    GChart,
    ErrorsMessages,
    Filters,
  },
  data() {
    return {
      chartsLib: null,
      dataReceive: [["CATEGORIA", "QUANTIDADE"]],
      dataPay: [["CATEGORIA", "QUANTIDADE"]],
      pay: [],
      total_pay: 0,
      receive: [],
      total_receive: 0,
      period_result: 0,
      max_progress: 100,
      all_account: true,
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      filter_by_period: false,
      cash_competence: "cash",
      month: moment().format("YYYY-MM"),
      month_tmp: moment().format("YYYY-MM"),
      dayMonthYear: "month",
      account_ids: [],
      types_of_entries_ids: [],
      users_ids: [],
      provider_ids: [],
      finance_client_ids: [],
      finance_configuration_document_types_ids: [],
      finance_configuration_payment_methods_ids: [],
      finance_configuration_category_ids: [],
      finance_configuration_profit_cost_center_ids: [],
      finance_configuration_tag_ids: [],
      cost_types_ids: [],
      cost_appropriations_ids: [],

      users: [],
      providers: [],
      finance_client: [],
      finance_configuration_account: [],
      finance_configuration_document_types: [],
      finance_configuration_payment_methods: [],
      finance_configuration_category: [],
      finance_configuration_category_parents: [],
      finance_configuration_profit_cost_center: [],
      finance_configuration_tag: [],
      cost_types: [
        { value: "FIXO", description: "FIXO" },
        { value: "VARIAVEL", description: "VARIÁVEL" },
      ],
      cost_appropriations: [
        { value: "DIRETO", description: "DIRETO" },
        { value: "INDIRETO", description: "INDIRETO" },
      ],
      loading: false,
      errors: [],
    };
  },
  async created() {
    await this.financeConfigurationAccount();
    await this.get();
    await this.getUsers();
    await this.provider();
    await this.financeClient();
    await this.financeConfigurationPaymentMethods();
    await this.financeConfigurationDocumentTypes();
    await this.financeConfigurationCategory();
    await this.financeConfigurationProfitCostCenter();
    await this.financeConfigurationTag();
  },
  methods: {
    formatMoney,
    handleSuccessFilters(data) {
      let {
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
      } = data;

      this.types_of_entries_ids = types_of_entries_ids;
      this.users_ids = users_ids;
      this.provider_ids = provider_ids;
      this.finance_client_ids = finance_client_ids;
      this.finance_configuration_document_types_ids =
        finance_configuration_document_types_ids;
      this.finance_configuration_payment_methods_ids =
        finance_configuration_payment_methods_ids;
      this.finance_configuration_category_ids =
        finance_configuration_category_ids;
      this.finance_configuration_profit_cost_center_ids =
        finance_configuration_profit_cost_center_ids;
      this.finance_configuration_tag_ids = finance_configuration_tag_ids;
      this.cost_types_ids = cost_types_ids;
      this.cost_appropriations_ids = cost_appropriations_ids;

      this.$bvModal.hide("filters");
      this.get();
    },
    handleAllAccount(all) {
      let { finance_configuration_account } = this;

      if (all) {
        for (let item of finance_configuration_account) {
          this.account_ids.push(item.id);
        }
        this.all_account = true;
      } else {
        this.account_ids = [];
        this.all_account = false;
      }
    },
    handleAccount() {
      let { account_ids, finance_configuration_account } = this;

      if (finance_configuration_account.length > account_ids.length) {
        this.all_account = false;
      } else {
        this.all_account = true;
      }
    },
    handleCancelFilters() {
      this.types_of_entries_ids = [];
      this.users_ids = [];
      this.provider_ids = [];
      this.finance_client_ids = [];
      this.finance_configuration_document_types_ids = [];
      this.finance_configuration_payment_methods_ids = [];
      this.finance_configuration_category_ids = [];
      this.finance_configuration_profit_cost_center_ids = [];
      this.finance_configuration_tag_ids = [];
      this.cost_types_ids = [];
      this.cost_appropriations_ids = [];

      this.$bvModal.hide("filters");
      this.get();
    },
    handleClickCashCompetence(cash_competence) {
      if (this.cash_competence != cash_competence) {
        this.cash_competence = cash_competence;
        this.get();
      }
    },
    handlePrint() {
      let {
        cash_competence,
        month,
        dayMonthYear,
        account_ids,
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
        filter_by_period,
        start_date,
        end_date,
      } = this;

      let route = this.$router.resolve({
        name: "print-releases-by-profit-cost-center",
        params: {
          cash_competence,
          month,
          dayMonthYear,
          account_ids: account_ids.join(","),
          types_of_entries_ids:
            types_of_entries_ids.length > 0
              ? types_of_entries_ids.join(",")
              : false,
          users_ids: users_ids.length > 0 ? users_ids.join(",") : false,
          provider_ids:
            provider_ids.length > 0 ? provider_ids.join(",") : false,
          finance_client_ids:
            finance_client_ids.length > 0
              ? finance_client_ids.join(",")
              : false,
          finance_configuration_document_types_ids:
            finance_configuration_document_types_ids.length > 0
              ? finance_configuration_document_types_ids.join(",")
              : false,
          finance_configuration_payment_methods_ids:
            finance_configuration_payment_methods_ids.length > 0
              ? finance_configuration_payment_methods_ids.join(",")
              : false,
          finance_configuration_category_ids:
            finance_configuration_category_ids.length > 0
              ? finance_configuration_category_ids.join(",")
              : false,
          finance_configuration_profit_cost_center_ids:
            finance_configuration_profit_cost_center_ids.length > 0
              ? finance_configuration_profit_cost_center_ids.join(",")
              : false,
          finance_configuration_tag_ids:
            finance_configuration_tag_ids.length > 0
              ? finance_configuration_tag_ids.join(",")
              : false,
          cost_types_ids:
            cost_types_ids.length > 0 ? cost_types_ids.join(",") : false,
          cost_appropriations_ids:
            cost_appropriations_ids.length > 0
              ? cost_appropriations_ids.join(",")
              : false,
          filter_by_period,
          start_date,
          end_date,
        },
      });

      window.open(route.href, "_blank");
    },
    handlePrevMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).subtract(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).subtract(1, "year").format("YYYY");
      }
      this.get();
    },
    handleNextMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month).add(1, "days").format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).add(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).add(1, "year").format("YYYY");
      }

      this.get();
    },
    handleDayMonthYear(dayMonthYear) {
      if (dayMonthYear == this.dayMonthYear) {
        return;
      }

      let { month, month_tmp } = this;

      this.month = moment().format("YYYY-MM-DD");

      if (dayMonthYear == "month") {
        this.month = moment(month_tmp).format("YYYY-MM");
        this.month_tmp = moment(month_tmp).format("YYYY-MM");
      }

      if (dayMonthYear == "year") {
        this.month = moment(month).format("YYYY");
        this.month_tmp = moment(month_tmp).format("YYYY-MM-DD");
      }

      this.dayMonthYear = dayMonthYear;
      this.get();
    },
    handleInputMonthTypeYear(year) {
      if (String(year).length == 4) {
        if (isNumeric(year)) {
          this.get();
        }
      }
    },
    handleModalFilterByPeriod() {
      this.$bvModal.show("period");
    },
    handleCancelFilterByPeriod() {
      this.$bvModal.hide("period");
      this.start_date = moment().format("YYYY-MM-DD");
      this.end_date = moment().format("YYYY-MM-DD");
      this.filter_by_period = false;
      this.get();
    },
    handleFilterByPeriod() {
      let { start_date, end_date } = this;

      if (!start_date) {
        this.errors = ["Informe a data inicial"];
        return;
      }

      if (!end_date) {
        this.errors = ["Informe a data final"];
        return;
      }

      if (
        parseInt(moment(start_date).format("YYYYMMDD")) >
        parseInt(moment(end_date).format("YYYYMMDD"))
      ) {
        this.errors = ["Informe a data final igual ou maior a data inicial"];
        return;
      }

      this.filter_by_period = true;
      this.get();
    },
    async getUsers() {
      try {
        const response = await api.get("/rest-home/users-actives");

        const { users } = response.data;

        this.users = users;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationAccount() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/account-actives"
        );

        const { data } = response.data;

        if (this.account_ids.length == 0) {
          for (let item of data) {
            this.account_ids.push(item.id);
          }
        }

        this.finance_configuration_account = data;
      } catch (error) {
        console.log(error);
      }
    },
    async provider() {
      try {
        const params = { active: 1 };
        const response = await api.get("/rest-home/providers", {
          params,
        });

        const { providers } = response.data;

        this.providers = providers;
      } catch (error) {
        console.log(error);
      }
    },
    async financeClient() {
      try {
        const response = await api.get("/rest-home/financial/client-actives");

        const { data } = response.data;

        this.finance_client = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationPaymentMethods() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods-actives"
        );

        const { data } = response.data;

        this.finance_configuration_payment_methods = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationDocumentTypes() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/document-types-actives"
        );

        const { data } = response.data;

        this.finance_configuration_document_types = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationCategory() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/category-actives"
        );

        const { data } = response.data;

        let parents = [];
        let daughters = [];
        for (let item of data) {
          if (item.type == "parent") {
            parents.push(item);
          } else {
            daughters.push(item);
          }
        }

        for (let parent of parents) {
          parent.items = [];
          for (let daughter of daughters) {
            if (daughter.finance_configuration_category_id == parent.id) {
              parent.items.push(daughter);
            }
          }
        }

        this.finance_configuration_category_parents = parents;
        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationProfitCostCenter() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives"
        );

        const { data } = response.data;

        this.finance_configuration_profit_cost_center = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationTag() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/tags-actives"
        );

        const { data } = response.data;

        this.finance_configuration_tag = data;
      } catch (error) {
        console.log(error);
      }
    },
    async get() {
      try {
        this.loading = true;

        this.dataReceive = [["CATEGORIA", "QUANTIDADE"]];
        this.dataPay = [["CATEGORIA", "QUANTIDADE"]];

        let {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        } = this;

        let params = {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        };

        const response = await api.get(
          "/rest-home/financial/reports/releases-by-profit-cost-center",
          { params }
        );

        const { error, errors, pay, total_pay, receive, total_receive } =
          response.data;

        if (error) {
          this.errors = errors;
          this.receive = [];
          this.total_receive = 0;
          this.pay = [];
          this.total_pay = 0;
          this.max_progress = 0;
          this.period_result = 0;
        } else {
          this.errors = [];
          let pays = [];
          let receives = [];

          for (let item of receive) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataReceive.push([
                item.description,
                parseFloat(`${init}.${end}`),
              ]);
              let percentage = (item.total * 100) / total_receive;
              percentage = percentage.toFixed(2);
              receives.push({ ...item, percentage });
            }
          }

          for (let item of pay) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataPay.push([
                item.description,
                parseFloat(`${init}.${end}`),
              ]);
              let percentage = (item.total * 100) / total_pay;
              percentage = percentage.toFixed(2);
              pays.push({ ...item, percentage });
            }
          }

          this.receive = receives;
          this.total_receive = total_receive;
          this.pay = pays;
          this.total_pay = total_pay;

          if (parseFloat(total_pay) >= parseFloat(total_receive)) {
            this.max_progress = total_pay;
          } else {
            this.max_progress = total_receive;
          }

          this.period_result =
            parseFloat(total_receive) - parseFloat(total_pay);

          this.$bvModal.hide("account");
          this.$bvModal.hide("period");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
